<template>
  <div class="top">
    <div class="inner">
      <img class="logo" src="/img/logo.png" alt="こどもの学び応援サイト まなびアサヒ.com">
      <div class="catch">
        <MainCard :posts="top.posts" v-if="top&&top.posts&&top.posts[0]" />
        <ul class="small-thumb">
          <SubCard :thumb="thumb" :key="'thumb-search' + i" v-for="(thumb, i) in small_thumb" />
        </ul>
      </div>
      <div class="contents">
        <SearchTop/>
        <p class="pagetop"><a class="alp" href="#">ページトップへ</a></p>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;
.top {
  .inner {
    max-width: 1000px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10px;
  }
  .logo {
    display: block;
    margin: 55px auto 60px;
    width: 443px;
  }
  .catch {
    @include flex();
    a {
      display: block;
      background: #fff;
    }
    img {
      width: 100%;
    }
    .main-thumb {
      width: 50.409%;
      background: #fff;
      h3 {
        font-size: 18px;
        font-weight: bold;
        height: 1.1em;
      }
      .desc {
        padding: 25px 20px;
        p {
          font-size: 12px;
          font-weight: bold;
          margin-top: 15px;
          height: 1em;
        }
      }
    }
    .small-thumb {
      width: 48.062%;
      font-size: 12px;
      font-weight: bold;
      @include flex();
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-align-content: space-between;
      align-content: space-between;
      li {
        width: 48.41%;
        background: #fff;
        a {
          .desc {
            padding: 10px;
            line-height: 1.4;
            h3 {
              height: 2.8em;
            }
          }
        }
      }
    }
  }
  // .tab-btn
  .tab-btn {
    margin: 50px 0 25px;
    ul {
      @include flex();
      align-items: flex-end;
    }
    .btn {
      width: 31.43%;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 2.6;
      border-radius: 3px;
      cursor: pointer;
      background: #fff;
      overflow: hidden;
      span {
        width: 100%;
        display: block;
      }
    }
    .concour span {
      background: $concour;
    }
    .teaching span {
      background: $teaching;
    }
    .event span {
      background: $event;
    }
    .concour.show {
      background: url(../assets/img/common/top_tab01_pc.png) no-repeat;
    }
    .teaching.show {
      background: url(../assets/img/common/top_tab02_pc.png) no-repeat;
    }
    .event.show {
      background: url(../assets/img/common/top_tab03_pc.png) no-repeat;
    }
    .btn.show {
      margin-bottom: -10px;
      line-height: 3.8;
      padding-bottom: 10px;
      background-size: 100% auto;
      cursor: default;
      span {
        opacity: 1 !important;
        background: none;
      }
    }
  }
  // .tab-contents
  .tab-contents {
    display: none;
    .to-list-btn {
      width: 48.98%;
      margin: 40px auto 0;
      background: #fff;
      span {
        padding-left: 24px;
        &:before {
          content: " ";
          border: 8px dashed transparent;
          left: 0;
        }
      }
    }
    &.concour {
      .select-area {
        margin-bottom: 38px;
        label {
          color: $concour;
        }
        span {
          background: $concour;
        }
        input {
          background-color: $concour;
        }
      }
      .to-list-btn a {
        color: $concour;
        border: 3px solid $concour;
        span:before {
          border-left: 12px solid $concour;
        }
      }
    }
    &.teaching {
      .select-area {
        margin-bottom: 38px;
        label {
          color: $teaching;
        }
        span {
          background: $teaching;
        }
        input {
          background-color: $teaching;
        }
      }
      .to-list-btn a {
        color: $teaching;
        border: 3px solid $teaching;
        span:before {
          border-left: 12px solid $teaching;
        }
      }
    }
    &.event {
      .select-area {
        margin-bottom: 38px;
        label {
          color: $event;
        }
        span {
          background: $event;
        }
        input {
          background-color: $event;
        }
      }
      .to-list-btn a {
        color: $event;
        border: 3px solid $event;
        span:before {
          border-left: 12px solid $event;
        }
      }
    }
    &.show {
      display: block;
    }
  }
  .select-area {
    .search-btn {
      width: 102px;
    }
  }

  @media only screen and (max-width: 1000px) {
    .tab-btn .btn.show {
      line-height: 5.3vw;
    }
  }
  @media only screen and (max-width: 750px) {
    .inner {
      padding: 0;
    }
    .logo {
      width: 71vw;
      margin: 11vw auto;
    }
    .catch {
      display: block;
      .main-thumb {
        width: 100%;
        h3 {
          font-size: 1.28rem;
        }
        .desc {
          padding: 5vw 4vw;
          p {
            font-size: 0.8rem;
          }
        }
      }
      .small-thumb {
        width: 100%;
        li {
          width: 47.8%;
          margin-top: 4.4%;
          h3 {
            font-size: 0.8rem;
          }
        }
      }
    }
    .tab-btn {
      margin: 11vw 0 8vw;
      .btn {
        font-size: 1.28rem;
        line-height: 2.2;
      }
      .concour.show {
        background: url(../assets/img/common/top_tab01_sp.png) no-repeat;
      }
      .teaching.show {
        background: url(../assets/img/common/top_tab02_sp.png) no-repeat;
      }
      .event.show {
        background: url(../assets/img/common/top_tab03_sp.png) no-repeat;
      }
      .btn.show {
        width: 32.6%;
        background-size: 100% auto;
        line-height: 2.6;
        padding: 0.1em 0 0.5em;
        margin-bottom: -0.5em;
      }
    }
    .tab-contents {
      .select-area {
        .search-btn {
          width: 100%;
          margin-top: 6%;
        }
      }
      .to-list-btn {
        border: 1.5px solid $concour;
        margin: 8vw auto 9.5vw;
        span {
          padding-left: 4.8vw;
          &:before {
            border: 1.6vw dashed transparent;
            border-left: 2.4vw solid $concour;
          }
        }
      }
      &.concour {
        .to-list-btn {
          border: 1.5px solid $concour;
          span:before {
            border-left: 2.4vw solid $concour;
          }
        }
      }
      &.teaching {
        .to-list-btn {
          border: 1.5px solid $teaching;
          span:before {
            border-left: 2.4vw solid $teaching;
          }
        }
      }
      &.event {
        .to-list-btn {
          border: 1.5px solid $event;
          span:before {
            border-left: 2.4vw solid $event;
          }
        }
      }
    }
  }
}
</style>

<script>
import Base from "./_Base";
import SearchTop from "../components/top/SearchTop.vue";
import MainCard from "../components/top/MainCard.vue";
import SubCard from "../components/top/SubCard.vue";
export default {
  mixins: [Base],
  computed: {
    top() {
      return this.$store.state.data.top || {};
    },
    small_thumb() {
      if (!this.top.posts) {
        return [];
      }
      var ary = this.top.posts.concat();
      ary.shift();
      return ary;
    }
  },
  components: {
    SearchTop,
    MainCard,
    SubCard
  }
};
</script>
